export interface BreadcrumbItem {
  label: string;
  path?: string;
  isActive?: boolean;
}

interface NavigationBreadcrumbParams {
  organizationId: string | number;
  mazarName?: string | 'Mazar';
  category?: string | '-';
  trustRegNumber?: string | '-';
  trustRegId?: string | '-';
  surveyNumber?: string | '-';
  landId?: string | '-';
  includeSurvey?: boolean;
}

export const getNavigationBreadcrumbs = ({
  organizationId,
  mazarName,
  category,
  trustRegNumber,
  trustRegId,
  surveyNumber,
  landId,
  includeSurvey = false,
}: NavigationBreadcrumbParams): BreadcrumbItem[] => {
  const items: BreadcrumbItem[] = [
    {
      label: 'Dashboard',
      path: '/dashboard',
    },
    {
      label: mazarName || 'Mazar',
      path: `/organizations/${organizationId}/choose-category?mazar_name=${mazarName}`,
    },
  ];

  if (category === 'Trust' || category === 'Waqf') {
    items.push({
      label: category,
      path: `/organizations/${organizationId}/registration-board?mazar_name=${mazarName}&category=${category}`,
    });

    if (trustRegNumber) {
      items.push({
        label: trustRegNumber,
        path: trustRegId
          ? `/organizations/${organizationId}/registration-board/${trustRegId}/lands?mazar_name=${mazarName}&category=${category}&trustRegNumber=${trustRegNumber}`
          : `/organizations/${organizationId}/lands?mazar_name=${mazarName}&category=${category}&trustRegNumber=${trustRegNumber}`,
      });
    }

    if (includeSurvey && surveyNumber && landId) {
      items.push({
        label: surveyNumber,
        path: `/organizations/${organizationId}/lands/${landId}?mazar_name=${mazarName}&category=${category}&trustRegNumber=${trustRegNumber}&surveyNumber=${surveyNumber}&trustRegId=${trustRegId}`,
      });
    }
  }

  if (category === 'unregistered') {
    items.push({
      label: category.charAt(0).toUpperCase() + category.slice(1),
      path: `/organizations/${organizationId}/lands?mazar_name=${mazarName}&category=${category}`,
    });

    if (includeSurvey && surveyNumber && landId) {
      items.push({
        label: surveyNumber,
        path: `/organizations/${organizationId}/lands/${landId}?mazar_name=${mazarName}&category=${category}&surveyNumber=${surveyNumber}`,
      });
    }
  }

  return items;
};
